import { Phone } from "lucide-react";

const MobileCallBar = () => (
  <div
    data-testid="mobile-call-bar"
    className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#16324a] border-t-2 border-[#e8c78f] shadow-[0_-8px_30px_rgba(15,35,52,0.35)]"
    style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
  >
    <a
      data-testid="mobile-call-link"
      href="tel:6104534448"
      className="flex items-center justify-center gap-3.5 py-4 px-6 active:bg-[#0f2334] transition-colors duration-200"
    >
      <span className="w-11 h-11 rounded-full bg-[#e8c78f] text-[#16324a] flex items-center justify-center shrink-0">
        <Phone size={20} strokeWidth={2.25} />
      </span>
      <span className="flex flex-col items-start leading-tight">
        <span className="font-serif text-lg text-white">Tap Here to Call Us</span>
        <span className="text-xs tracking-wider text-[#e8c78f] font-semibold">(610) 453-4448</span>
      </span>
    </a>
  </div>
);

export default MobileCallBar;
